import React, { FC, memo } from "react";

import { IConsultantProfile } from "@/data/consultant-profiles";
import { Flex } from "@/eworkitComponents";

import { ContextDropdownProfile } from "./ContextDropdownProfile";

export interface IContextDropdownProfilesListProps {
  profiles: IConsultantProfile[];
  onProfileClick: (profile: IConsultantProfile) => void;
  showNotificationsCounter?: boolean;
}

export const ContextDropdownProfilesList: FC<IContextDropdownProfilesListProps> = memo(props => {
  return props.profiles.length ? (
    <div>
      <Flex direction="column">
        {props.profiles.map(profile => (
          <ContextDropdownProfile key={profile.id} profile={profile} onClick={props.onProfileClick} />
        ))}
      </Flex>
    </div>
  ) : null;
});
